import { TextField } from "@mui/material";
import PropTypes from "prop-types";

import Chips from "./Filters/Chips";

const Search = ({ currentSearchValue, setSearchState }) => {
  return (
    <div className="">
      <div className="mx-3 flex items-center">
        <TextField
          className="w-full rounded-lg text-sm placeholder:text-center"
          placeholder={"Search by client name, follow-up details, assigned user, creation user"}
          size="small"
          name="callLog-search"
          value={currentSearchValue}
          InputLabelProps={{ shrink: true }}
          label="Search"
          onChange={(event) => {
            let searchVal = event.target.value;
            searchVal = searchVal.length === 0 ? " " : searchVal;
            setSearchState(searchVal);
          }}
        />
      </div>
      <Chips currentSearchValue={currentSearchValue} setSearchState={setSearchState} />
    </div>
  );
};

export default Search;

Search.propTypes = {
  currentSearchValue: PropTypes.string,
  setSearchState: PropTypes.func,
};
